import React, { useEffect } from 'react';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import DashboardActions from './DashboardActions';
import { getCurrentProfile, clearProfile, cleargid } from '../../actions/profile';
import { ListGroup, ListGroupItem } from 'reactstrap';
const {COMMUNITY, CASTE} = require("../../Constant");

const Dashboard = ({
  getCurrentProfile,
  clearProfile,
  auth: { user },
  profile: { profile }
}) => {

  const navigate = useNavigate();

  useEffect(() => {
    if(user !== null && user !== undefined && user.ltype.toString() === "ZZ")
      {
         navigate("/select-tfc");
      }

    if(profile !== null && profile !== undefined) {
      
      //getCurrentProfile(profile.e);
      cleargid();      
    }
  }, [getCurrentProfile, profile, cleargid, user]);


  const clearNext = async() => {
    //clearProfile(history, "3");   
    await clearProfile();
    navigate("/search-profile");
  }

  return (
    <section className="container">
      {/* <h1 className="large text-primary">{user.tfcname}</h1> */}

      <h3 style={{color: "brown"}}> TNEA 2025 </h3>
      <h2 style={{color: "navy"}}> Grievance System </h2>
      <br></br>
      <p className="lead">
        <i className="fas fa-user" /> Welcome <br/> {user && user.tfccode} -- {user && user.tfcname}
      </p>
      {/* <div style={{textAlign: "right"}}>
      <button
          onClick={() => cclearProfile()}
          className="btn btn-light" style={{alignItems: "right"}}
        >
          Clear Search
      </button>
      </div> */
      
      }

      <br></br>

        <div className="form-group" style={{textAlign: "right"}}>          
          <input type="submit" className='btn btn-danger'  value="Clear / New Search" onClick= {e => clearNext(e)} />    
        </div>

      {profile !== null ? (
        <>
        <h2 className="my-2">Candidate Details</h2>
        <table className="table">
        <thead>
          <tr>
            <th>Candidate Name</th>
            <th className="hide-sm">Email</th>
            <th className="hide-sm">Application number</th>
            {/* <th className="hide-sm">Mobile number</th> */}
            <th className="hide-sm">Photo</th>
            
            <th className="hide-sm">CV Status</th>            
            <th className="hide-sm">7.5% Gov. School Status</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td> {profile._n} </td>
            <td> {profile.e} </td>
            <td> {profile._aid} </td>
            {/* <td> {profile.m} </td> */}
            <td>
            <img className="" style={{height: '250px', width: 'auto'}} src= {profile._docs.filter((e) => e.id.toString() === "passport_photo").map((e) => e.durl)} alt="Photo-Not-Uploaded" />
            </td>
           
            <td> {profile.cv !== undefined && profile.cv !== null ? (profile.cv.st.toString() === "vcomplete" || profile.cv.st.toString() === "ucomplete" || profile.cv.st.toString() === "ccomplete" || profile.cv.st.toString() === "acomplete" ? "successful" : profile.cv.st) : "Not applicable"}
            <br/> {profile.cv !== undefined && profile.cv !== null && profile.cv.st !== null && profile.cv.st !== undefined && profile.cv.st.toString() === "ineligible" ? profile.cv.inel[profile.cv.inel.length-1].cr : ""}
            </td>
            <td> Claimed : {profile._sc && profile._sc.sigsc && profile._sc.sigsc.toString() === "Y" ? "Yes": "No"} <br/> 
            {profile._sc && profile._sc.sigsc && profile._sc.sigsc.toString() === "Y" &&
            <span>Current Status : {profile._govSc !== undefined && profile._govSc === true ? "Eligible" : "Not Eligible"} </span>} </td>
          </tr>
        </tbody>
        </table>
<br/>
{profile.cv && profile.cv.st !== null && profile.cv.st !== undefined && profile.cv.st.toString() !== "ineligible" &&
<table className="table">
        <thead>
          <tr>
            <th className="hide-sm">Community & Caste</th>
            <th className="hide-sm">Marks</th>
            <th className="hide-sm">General Rank</th>
            <th className="hide-sm">Sports Rank</th>
            <th className="hide-sm">Ex-Ser Rank</th>
            <th className="hide-sm">Diff. abled Rank</th>
            <th className="hide-sm">Gov. School 7.5% Rank</th>            
          </tr>
        </thead>
        <tbody>
          <tr>
          <td>{profile._p && profile._p.co && COMMUNITY.filter(e => e.key.toString() === profile._p.co.toString()).map(e => e.label)} - {profile._p && profile._p.cas && CASTE[profile._p.co].filter(e => e.key.toString() === profile._p.cas.toString()).map(e => e.label)} </td>
          <td>
            <ListGroup>              
              {profile._ac && profile._ac.hg && profile._ac.hg.toString() === "1" ? 
                <div>
                <ListGroupItem> Mathematics: <span style={{fontWeight: 'bold'}}> {profile._ac.mmo && profile._ac.mmo} / {profile._ac.mmt && profile._ac.mmt} </span> </ListGroupItem> 
                <ListGroupItem> Physics: <span style={{fontWeight: 'bold'}}> {profile._ac.pmo && profile._ac.pmo} / {profile._ac.pmt && profile._ac.pmt} </span> </ListGroupItem> 
                <ListGroupItem> Chemistry: <span style={{fontWeight: 'bold'}}> {profile._ac.cmo && profile._ac.cmo} / {profile._ac.cmt && profile._ac.cmt} </span> </ListGroupItem> 
                <ListGroupItem> Optional: <span style={{fontWeight: 'bold'}}> {profile._ac.omo && profile._ac.omo} / {profile._ac.omt && profile._ac.omt} </span> </ListGroupItem>                   
                <ListGroupItem> HSC TOTAL Marks: <span style={{fontWeight: 'bold'}}> {profile._ac && profile._ac.hscobm} / {profile._ac.hsctm} </span> </ListGroupItem>

                </div>
                :null}

                {profile._ac && profile._ac.qe !== "1" ?                
                <div> 
                <ListGroupItem> Mathematics: <span style={{fontWeight: 'bold'}}> {profile._ac.mmo && profile._ac.mmo} / {profile._ac.mmt && profile._ac.mmt} </span> </ListGroupItem> 
                <ListGroupItem> Physics: <span style={{fontWeight: 'bold'}}> {profile._ac.pmo && profile._ac.pmo} / {profile._ac.pmt && profile._ac.pmt} </span> </ListGroupItem> 
                <ListGroupItem> Chemistry: <span style={{fontWeight: 'bold'}}> {profile._ac.cmo && profile._ac.cmo} / {profile._ac.cmt && profile._ac.cmt} </span> </ListGroupItem> 

                {profile._ac.omo !== '' ? 
                <ListGroupItem> Optional: <span style={{fontWeight: 'bold'}}> {profile._ac.omo && profile._ac.omo} / {profile._ac.omt && profile._ac.omt} </span> </ListGroupItem>                   
                    : 
                <ListGroupItem> Optional: <span style={{fontWeight: 'bold'}}> Nil  </span> </ListGroupItem>       }

                <ListGroupItem> HSC TOTAL Marks: <span style={{fontWeight: 'bold'}}> {profile._ac && profile._ac.hscobm} / {profile._ac.hsctm} </span> </ListGroupItem>                


                </div>
                :null}

                {profile._ac && profile._ac.hg && profile._ac.hg.toString() === "2" ? 
                <div>
                <ListGroupItem> M/P/C: <span style={{fontWeight: 'bold'}}> {profile._ac.mpcmo && profile._ac.mpcmo} / {profile._ac.mpcmt && profile._ac.mpcmt} </span> </ListGroupItem> 
                <ListGroupItem> Theory: <span style={{fontWeight: 'bold'}}> {profile._ac.tmo && profile._ac.tmo} / {profile._ac.tmt && profile._ac.tmt} </span> </ListGroupItem> 
                <ListGroupItem> Practical I: <span style={{fontWeight: 'bold'}}> {profile._ac.p1mo && profile._ac.p1mo} / {profile._ac.p1mt && profile._ac.p1mt} </span> </ListGroupItem> 
                <ListGroupItem> Practical II: <span style={{fontWeight: 'bold'}}> {profile._ac.p2mo && profile._ac.p2mo} / {profile._ac.p2mt && profile._ac.p2mt} </span> </ListGroupItem>                   
                <ListGroupItem> HSC TOTAL Marks: <span style={{fontWeight: 'bold'}}> {profile._ac && profile._ac.hscobm} / {profile._ac.hsctm} </span> </ListGroupItem>               

                </div>
                :null}

            </ListGroup>
                
            </td>
            <td> {profile.rkd && profile.rkd.r !== undefined && profile.rkd.r !== null ? profile.rkd.r : "NA"} </td>
            <td> {profile.rkd && profile.rkd.espr !== undefined && profile.rkd.espr !== null ? profile.rkd.espr : "NA"} </td>
            <td> {profile.rkd && profile.rkd.exr !== undefined && profile.rkd.exr !== null ? profile.rkd.exr : "NA"} </td>
            <td> {profile.rkd && profile.rkd.dapr !== undefined && profile.rkd.dapr !== null ? profile.rkd.dapr : "NA"} </td>
            <td> {profile.rkd && profile.rkd.govr !== undefined && profile.rkd.govr !== null ? profile.rkd.govr : "NA"} </td>

          </tr>
        </tbody>
        </table> 
}
 <br/>       
        <br/>
          <DashboardActions />
          
        </>
      ) : (
        <>
          <p>Search Candidate by application number / mobile number / email / hsc register number </p>
          <Link to="/search-profile" className="btn btn-success my-1">
            Search
          </Link>
        </>
      )}
    </section>
  );
};

Dashboard.propTypes = {
  getCurrentProfile: PropTypes.func.isRequired,
  clearProfile: PropTypes.func.isRequired,
  cleargid: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  profile: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  profile: state.profile
});

export default connect(mapStateToProps, { getCurrentProfile, clearProfile, cleargid })(
  Dashboard
);
